import { API_ROOT } from '../config/ApiConfig';
import { generateRequestHeaders } from '../service/ApiService';

export async function getAvailableFlexDiscounts(partnerId: string): Promise<any> {
    const response = await fetch(`${API_ROOT}/promotions/getAll?distributor-org-id=${partnerId}`, {
        headers: generateRequestHeaders(),
        method: 'GET'
    });

    const data = {httpstatus: 500, data: []};
    data.data = await response.json();
    data.httpstatus = response.status;
    return data;
}

export interface SetPromoEndDateResponse {
    httpstatus: number;
    reason?: string;
    message?: string;
    data?: any;
}

/** Normalize time to HH:mm:ss (HTML time input may return HH:mm). */
export function normalizeTimeToHms(time: string): string {
    const t = time.trim();
    if (/^\d{2}:\d{2}:\d{2}$/.test(t)) return t;
    if (/^\d{2}:\d{2}$/.test(t)) return `${t}:00`;
    return t;
}

/** Build API endDate as YYYY-MM-DDTHH:mm:ss (e.g. 2024-12-31T10:15:30). */
export function toEndDateTimeString(dateOnlyOrIso: string, timeHms: string): string {
    const trimmed = dateOnlyOrIso.trim();
    const datePart = trimmed.includes('T') ? trimmed.split('T')[0] : trimmed;
    return `${datePart}T${normalizeTimeToHms(timeHms)}Z`;
}

export async function setPromoEndDate(
    promoId: string,
    selectedEndDate: string,
    partnerId: string,
    selectedEndTime: string
): Promise<SetPromoEndDateResponse> {
    const endDate = toEndDateTimeString(selectedEndDate, selectedEndTime);
    const response = await fetch(`${API_ROOT}/promotions/${promoId}/endDate`, {
        headers: generateRequestHeaders(),
        method: 'PUT',
        body: JSON.stringify({
            endDate,
            partnerImsOrgId: partnerId,
            promoId: promoId
        })
    });

    let body: any = undefined;
    try {
        body = await response.json();
    } catch (e) {
        // ignore non-json response bodies
    }

    const result: SetPromoEndDateResponse = { httpstatus: response.status, data: body };
    if (!response.ok) {
        result.message = body?.message || 'Failed to update promotion end date';
        result.reason = body?.reason;
    }
    return result;
}